import request from '@/utils/request'

export function getLinks() {
  return request({
    url: 'links/GetLinks',
    method: 'post'
  })
}

export function getNoorLinks() {
  return request({
    url: 'links/GetNoorLinks',
    method: 'post'
  })
}



